/**
 * LoadingSkeleton - Content-shaped shimmer placeholders
 */

import './LoadingSkeleton.css';

export function LoadingSkeleton() {
  return (
    <div className="loading-skeleton">
      <div className="loading-skeleton__header">
        <div className="skeleton-bar skeleton-bar--md" />
        <div className="skeleton-bar skeleton-bar--sm" />
      </div>
      <div className="loading-skeleton__body">
        <div className="skeleton-block skeleton-block--large" />
        <div className="skeleton-sidebar">
          <div className="skeleton-block skeleton-block--small" />
          <div className="skeleton-block skeleton-block--small" />
        </div>
      </div>
    </div>
  );
}
